import React from 'react';
import PropTypes from 'prop-types';

import { Input as MuiInput } from '@material-ui/core';

const Input = ({ onChange, ...rest }) => {
  return (
    <MuiInput
      {...rest}
      onChange={onChange}
    />
  )
}

Input.defaultProps = {
  onChange: () => {},
}

Input.propTypes = {
  onChange: PropTypes.func,
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/base/Input/Input.js